<template>
    <div>
        <limitless-page-header></limitless-page-header>

        <div class="content" v-if="busy_loading">
            <i class="icon-spinner2 spinner"></i>
        </div>
        <div v-else class="content">
            <div class="card card-body">
                <div v-for="week in kitchen_schedule" :key="'week-' + week.week" style="font-size: 18px;">
                    <div v-if="week.users"><span class="font-weight-semibold">Vecka {{ week.week }}</span> - {{ week.users.map((user) => user.short_name).join(', ') }}</div>
                    <div v-else><span class="font-weight-semibold">Vecka {{ week.week }}</span> - Alla hjälps åt denna vecka</div>
                </div>
            </div>
        </div> <!-- /content -->
    </div>
</template>

<script>
import apiClient from '@services/ApiClient';
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader.vue';

export default {
    name: 'Birthdays',
    components: {
        LimitlessPageHeader,
    },
    data: () => ({
        busy_loading: true,
        kitchen_schedule: null,
    }),
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.busy_loading = true;
            const params = new URLSearchParams(document.location.search);
            const debug = params.get('debug');
            apiClient.get('/api/users/kitchen_schedule?debug=' + debug)
                .then((response) => {
                    this.kitchen_schedule = response.data;
                }).finally(() => {
                    this.busy_loading = false;
                });
        },
    },
};

</script>
